<template>
  <div>
    <van-sticky>
      <van-nav-bar
        title="添加场馆"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
      />
    </van-sticky>

    <van-form @submit="onSubmit">

      <van-field
        clearable
        v-model="vname"
        name="vname"
        label="场馆名"
        placeholder="场馆名"
        :rules="[{ required: true, message: '请填写场馆名' }]"
      />

      <van-field
        readonly
        clickable
        name="clubValue"
        :value="clubValue"
        label="归属俱乐部"
        placeholder="点击选择俱乐部"
        @click="clubShowPicker = true"
      />

      <van-popup class="popup" v-model="clubShowPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="getClubList"
          @confirm="clubOnConfirm"
          @cancel="clubShowPicker = false"
        />
      </van-popup>

      <!--      <van-cell title="第几周">-->
      <!--        <van-stepper theme="round" max="18" v-model="week" integer/>-->
      <!--      </van-cell>-->
      <!--      <van-cell title="周几">-->
      <!--        <van-stepper theme="round" max="7" v-model="day" integer/>-->
      <!--      </van-cell>-->


      <van-cell title="最大人数">
        <van-stepper theme="round" v-model="maxp" integer/>
      </van-cell>

      <van-field
        clearable
        v-model="location"
        name="location"
        label="场馆位置"
        placeholder="场馆位置"
        :rules="[{ required: true, message: '请填写场馆位置' }]"
      />

      <van-field
        v-model="notice"
        rows="2"
        autosize
        name="notice"
        clearable
        label="场馆公告"
        type="textarea"
        maxlength="500"
        placeholder="场馆公告"
        show-word-limit
        :rules="[{ required: true, message: '请填写场馆公告' }]"
      />

      <van-field
        readonly
        clickable
        :value="startTime"
        name="startTime"
        label="场馆预约时间"
        placeholder="点击选择场馆预约开始时间"
        @click="startTimeShowPicker = true"
      />

      <van-popup v-model="startTimeShowPicker" position="bottom">
        <van-datetime-picker
          v-model="currentDate1"
          type="datetime"
          title="场馆开始预约时间"
          @confirm="startOnConfirm"
          @cancel="startTimeShowPicker = false"
        />
      </van-popup>

      <van-field
        readonly
        clickable
        :value="openTime"
        name="openTime"
        label="场馆开放时间"
        placeholder="点击选择场馆开放时间"
        @click="openTimeShowPicker = true"
      />

      <van-popup v-model="openTimeShowPicker" position="bottom">
        <van-datetime-picker
          v-model="currentDate2"
          type="time"
          title="选择场馆开放时间"
          @confirm="OpenOnConfirm"
          @cancel="openTimeShowPicker = false"
        />
      </van-popup>

      <van-field
        readonly
        clickable
        :value="closeTime"
        name="closeTime"
        label="场馆关闭时间"
        placeholder="点击选择场馆关闭时间"
        @click="closeTimeShowPicker = true"
      />

      <van-popup v-model="closeTimeShowPicker" position="bottom">
        <van-datetime-picker
          v-model="currentDate3"
          type="time"
          title="选择场馆关闭时间"
          @confirm="closeOnConfirm"
          @cancel="closeTimeShowPicker = false"
        />
      </van-popup>
      <van-cell title="选择日期" :value="calendarText" @click="calendarShow = true"/>
      <van-calendar :min-date="minDate" :max-date="maxDate" v-model="calendarShow" type="multiple"
                    @confirm="onCalendarConfirm"/>
      <van-cell title="选择位置" :value="'经度：'+this.coordinate.lng+',纬度'+this.coordinate.lat" @click="selectLocation"/>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          添加场馆
        </van-button>
      </div>
    </van-form>
    <van-dialog v-model="mapShow" :title="'经度：'+this.coordinate.lng+',纬度'+this.coordinate.lat">
      <t-map v-model="coordinate" :hight="300"></t-map>
    </van-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  NavBar,
  Form,
  Field,
  Button,
  Picker,
  Popup,
  Dialog,
  Col,
  Row,
  DatetimePicker,
  Uploader,
  Stepper,
  Cell,
  Sticky,
  RadioGroup, Radio,
  Calendar
} from 'vant';

Vue.use(Form);
Vue.use(NavBar);
Vue.use(Field);
Vue.use(Button);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Dialog);
Vue.use(Col);
Vue.use(Row);
Vue.use(DatetimePicker);
Vue.use(Uploader);
Vue.use(Stepper);
Vue.use(Cell);
Vue.use(Sticky);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Calendar);
import {getClubList} from "@/network/club";
import {AddVenue} from "../../../network/venue";
import TMap from "@/components/content/TMap/TMap"

export default {
  name: "AddVenue",
  components: {
    TMap
  },
  data() {
    return {
      //Venue Name
      vname: '',

      //club list
      ClubList: [],
      clubValue: '',
      clubShowPicker: false,


      //Maximum number of people
      maxp: 1,

      //location
      location: "",

      //notice
      notice: "",

      //Rush venue time
      startTime: "",
      startUnixTime: "",
      startTimeShowPicker: false,
      currentDate1: new Date(),

      //open venue time
      openTime: "",
      openTimeShowPicker: false,
      currentDate2: '',

      //close venue time
      closeTime: "",
      closeTimeShowPicker: false,
      currentDate3: '',

      //Calendar 日历
      calendarShow: false,
      calendarText: '',
      calendarDate: [],
      minDate: new Date(),
      maxDate: this.GLOBAL.end_select_time,

      // map show dialog
      mapShow: false,
      coordinate: {
        // 纬度
        lat: 34.687650, // 经纬度可以先写死
        // 经度
        lng: 113.676959
      },

    }
  },
  activated() {
    getClubList().then(res => {
      this.ClubList = res;
    });
    let start = 1614528000000;
    // console.log(new Date(start).toLocaleString())
  },
  computed: {
    getClubList() {
      return this.ClubList.map(value => value.id + ':' + value.title + ':' + value.tId + ':' + value.tName + ':' + value.tGender);
    },

  },
  methods: {
    selectLocation() {
      this.mapShow = true;
    }
    ,
    Dialoginfo(title, message) {
      Dialog.alert({
        title,
        message
      }).then(() => {
        // on close
      });
    }
    ,
    onClickLeft() {
      // this.$router.back(-1);
      this.$router.replace("VenueMList");
    }
    ,
    clubOnConfirm(value) {
      this.clubValue = value;
      this.clubShowPicker = false;
    }
    ,
    startOnConfirm(value) {
      this.startTime = value.toLocaleString();
      this.startUnixTime = value.getTime();
      this.startTimeShowPicker = false;
    }
    ,
    OpenOnConfirm(value) {
      this.openTime = value;
      this.openTimeShowPicker = false;
    }
    ,
    closeOnConfirm(value) {
      this.closeTime = value;
      // console.log(this.closeTime);
      this.closeTimeShowPicker = false;
    }
    ,
    onCalendarConfirm(date) {
      this.calendarDate = date;
      this.calendarShow = false;
      this.calendarText = `选择了 ${date.length} 个日期`;
    }
    ,
    timeCompare(time1, time2) {
      let split1 = time1.split(':');
      let split2 = time2.split(':');
      if (parseInt(split1[0]) > parseInt(split2[0])) {
        return true;
      } else if (parseInt(split1[0]) === parseInt(split2[0])) {
        if (parseInt(split1[1]) > parseInt(split2[1])) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
    ,
    clearDate(dates) {
      for (let i = 0; i < dates.length; i++) {
        dates[i].setHours(0);
        dates[i].setMinutes(0);
        dates[i].setSeconds(0);
      }
      return dates;
    }
    ,
    getUnix(time) {
      let split = time.split(':');
      return 1000 * 60 * (parseInt(split[0]) * 60 + parseInt(split[1]))
    }
    ,
    onSubmit(values) {

      if (values.vname === ":") {
        this.Dialoginfo('提示', '场馆名不能为空');
      } else if (values.clubValue === "") {
        this.Dialoginfo('提示', '俱乐部不能为空');
      } else if (values.location === "") {
        this.Dialoginfo('提示', '位置不能为空');
      } else if (values.notice === "") {
        this.Dialoginfo('提示', '公告不能为空');
      } else if (this.startTime === "") {
        this.Dialoginfo('提示', '开始预约时间不能为空');
      } else if (this.openTime === "") {
        this.Dialoginfo('提示', '场馆开放时间不能为空');
      } else if (this.closeTime === "") {
        this.Dialoginfo('提示', '场馆关闭时间不能为空');
      } else if (this.calendarText === "") {
        this.Dialoginfo('提示', '日期不能为空');
      } else if (!this.timeCompare(this.closeTime, this.openTime)) {
        this.Dialoginfo('提示', '场馆关闭时间应该大于开放时间');
      } else {
        let date = this.clearDate(this.calendarDate);
        let dates = "";
        for (let i = 0; i < date.length; i++) {
          dates = dates + date[i].getTime();
          if (i != date.length - 1)
            dates = dates + ':';
        }
        let times = new Date();
        let info = values.clubValue.split(':');

        let open = this.getUnix(this.openTime);
        let close = this.getUnix(this.closeTime);
        AddVenue(values.vname, info[0], info[1], info[2], info[3], info[4], values.location, this.coordinate.lat, this.coordinate.lng, values.notice, this.maxp, this.startUnixTime, open, close, dates).then(res => {
          if (res.status) {
            // console.log(res);
            let msg = res.success.join() + '添加成功;';
            if (res.fail.length > 0)
              msg = msg + res.fail.join() + '添加失败';
            this.Dialoginfo('提示', '添加完成,' + msg);
          } else {
            this.Dialoginfo('提示', '添加失败');
          }
        }).catch(res => {
          this.Dialoginfo('提示', '添加失败');
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
